import {STATE_PROP_NAME} from './subfactor-health-badge-constants'

export const getRoot = state => state[STATE_PROP_NAME]
export const getStateByKey = (key, state) => getRoot(state)[key]
